import React from "react";
import { BiCategory } from "react-icons/bi";
import { Outlet } from "react-router-dom";
import ServiceViewLayout from "../../ServiceViewLayout/ServiceViewLayout";
import { FaCommentDollar } from "react-icons/fa6";
import { GrMoney } from "react-icons/gr";
type Props = {};

const TabITRServiceWrapper = (props: Props) => {

  const navItemsList = [
    {
      label: "Categories",
      path:"categories",
      icon: BiCategory,
    },
    {
      label: "Commission",
      path:"commission",
      icon: FaCommentDollar,
    },
    {
      label: "Reward",
      path:"reward",
      icon: GrMoney,
    },
  ];

  return (
    <ServiceViewLayout navItemList={navItemsList} >
      <Outlet/>
    </ServiceViewLayout>
  );
};

export default TabITRServiceWrapper;
